function client(url, options = {}) {
  const { headers = {}, ...rest } = options;

  return fetch(url, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      HTTP_X_REQUESTED_WITH: 'XMLHttpRequest',
      ...headers,
    },
    ...rest,
  });
}

export function textClient(url, options = {}) {
  return client(url, options).then((resp) => resp.text());
}

export function craftJsonClient(url, options = {}) {
  return client(url, {
    headers: {
      Accept: 'application/json',
    },
    ...options,
  }).then(async (resp) => {
    const json = await resp.json();
    if (!json.success) {
      return Promise.reject(json);
    }
    return json;
  });
}

export function jsonClient(url, options = {}) {
  return client(url, options).then((resp) => resp.json());
}

export default client;
